interface newUserTypes {
  email: string;
  password: string;
}

async function signInUser(user: newUserTypes) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/auth/sign-in`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
    credentials: "include",
  });
  const result = await response.json();

  return result;
}

export default signInUser;
